import { render, staticRenderFns } from "./TransbankPayment.vue?vue&type=template&id=63c98a8a&lang=pug&"
import script from "./TransbankPayment.vue?vue&type=script&lang=js&"
export * from "./TransbankPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TransbankPayment.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VDivider,
  VForm,
  VTextField,
})
